import styled from 'styled-components';
import { Media } from '../../styles/media';

const { tabletUp } = Media;

export const Container = styled.div`
  background-color: ${({ theme }) => theme.pearlGray};
  padding: 40px 24px;
`;

export const FlexContainer = styled.div`
  ${tabletUp`
    display: flex;
    justify-content: center;
  `};
`;

export const LeftContainer = styled.div`
  width: 100%;
  max-width: 380px;

  ${tabletUp`
    margin-right: 100px;
  `};
`;

export const SocialPadding = styled.div`
  padding: 40px 0;
`;

export const RightContainer = styled.div`
  margin-top: 40px;

  ${tabletUp`
    margin-top: 0;
  `};
`;
